// extracted by mini-css-extract-plugin
export var button = "share-buttons-module--button--ADnNZ";
export var shareButtons = "share-buttons-module--share-buttons--1aSMt";
export var shareText = "share-buttons-module--share-text--ft9ec";